export default __webpack_public_path__ + "static/media/gift-gold-icon.6053c310.svg";